import styled from "styled-components";

export const CategoryIcon = styled.img`
  width: 35px;
  height: 35px;
  margin-right: 10px;
`;
